import { CnDetailInfo } from '@/components/cn-detail-info';

export default CnDetailInfo;
